export default __webpack_public_path__ + "locales/si/ChangeUserTypeDialog.json?hash=bcda332423c192d2768b35dc0b2da752";